module.exports = __webpack_public_path__ + "static/background_club-8f594d75b303286cda0e7286a5d36a03.gif";